module.exports = __webpack_public_path__ + "img/cash-on-delivery.27390fc7.png";